import { render, staticRenderFns } from "./cogsDash.vue?vue&type=template&id=5a8bd719&scoped=true"
import script from "./cogsDash.vue?vue&type=script&lang=js"
export * from "./cogsDash.vue?vue&type=script&lang=js"
import style0 from "./cogsDash.vue?vue&type=style&index=0&id=5a8bd719&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8bd719",
  null
  
)

export default component.exports